<template>
    <div class="ppa-quote-email">
        <div class="row ppa-quote-header">
            <div class="col-sm-8 separator-left-big" style="height: 100%;">
                <img class="logo-img-small" height="100px" src="https://www.thetruckersreport.com/wordpress/wp-content/themes/truckersreport/images/tr-logo.svg" />
            </div>
            <div class="col-sm-4 ppa-quote-address separator-left">
                <div>1887 Whitney Mesa Dr #1040</div>
                <div>Henderson, NV 89014</div>
                <div class="bold">TruckersReport.com</div>
            </div>
        </div>
        <div class="text-panel">
            <div class="date-field">Date: <span v-text="date"></span></div>
            <div class="content">
                <rich-text-area class="form-control" :is-view-only="!isEditable"
                                v-model="emailText" v-on:input="onTextChanged"
                ></rich-text-area>
            </div>
        </div>
        <editable-table v-if="localValue" v-model.lazy="localValue.tableData"
                        :columns-sizes="['50%']"
                        v-on:input="onTableDataChanged" :is-editable="isEditable"

        ></editable-table>
        <div>
            <h2>Hiring Map:</h2>
            <div class="map">
                <img v-if="localValue" :src="hiringAreaMap" />
            </div>
        </div>
        <rich-text-area class="form-control" style="margin-top: 20px" :is-view-only="!isEditable"
                        v-if="localValue" v-model="localValue.footerText" v-on:input="emitUpdateData()"
        ></rich-text-area>
    </div>
</template>

<script>
    export default {
        props:{
            value: Object,
            isEditable: Boolean
        },
        name: "ppa-quote",
        data() {
            return {
                date: moment().format('dddd, MMMM DD, YYYY'),
                emailText: null,
                localValue: null,
                isInitialized: false
            };
        },
        computed: {
            hiringAreaMap() {
                return this.localValue.hiringAreaMap + '?a=' + _.random(1, 1000);
            }
        },
        methods: {
            emitUpdateData(){
                if(!this.isInitialized){
                    return;
                }
                this.$emit('input', _.cloneDeep(this.localValue));
            },
            initializeLocalValue(){
                if(!this.value){
                    return;
                }
                this.isInitialized = false;
                this.localValue = _.cloneDeep(this.value);
                this.emailText = this.localValue.text;
                this.isInitialized = true;
            },
            onTableDataChanged(){
                this.emitUpdateData();
            },
            onTextChanged(val){
                this.localValue.text = val;
                this.emitUpdateData();
            },
        },
        watch: {
            value(){
                this.initializeLocalValue();
            }
        },
        mounted(){
            this.initializeLocalValue();
        }
    }
</script>

<style scoped>
    .ppa-quote-email{
        width: 1000px;
        margin: 0 auto;
    }
    .ppa-quote-header{
        height: 100px;
        margin-bottom: 40px;
    }
    .ppa-quote-address {
        font-size: 20px;
        height: 100%;
    }
    .bold {
        font-weight: bold;
    }
    .separator-left{
        border-left: 5px solid #2D3E4F
    }
    .separator-left-big{
        border-left: 25px solid #2D3E4F
    }

    .text-panel {
        margin: 20px 0 20px 0;
    }
    .text-panel .date-field{
        text-align: right;
        margin: 20px 0;
        font-size: 20px;
    }
    .text-panel .content {
        flex: 1;
    }
    .text-panel .left-column {
        flex: 1;
    }
    .text-panel textarea {
        width: 100%;
        min-height: 200px;
    }
    .text-panel .right-column {
        flex: 1;
    }
    .map {
        background: transparent;
        text-align: center;
    }
    .company-name {
        font-size: 20px;
    }
</style>
<style>
    .ppa-quote-email .table-header {
        vertical-align: bottom;
    }
    .ppa-quote-email .table-header th {
        background: #004784;
        color: white;
        height: 50px;
        padding-top: 20px;

    }
</style>